import React from "react";
import { Button, Box, Typography, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import muiCustomStyles from "./styles/styles";
import CustomTooltip from "../../../Components/CustomTooltip";
import GenericSwiperDialog from "../../../Components/Modals/GenericSwiperDialog";
import { useSnackbar } from "../../../Components/SnackBar";

const LeftSlide = () => {
  const { t } = useTranslation(["welcome", "bottom-menu-and-settings"]);
  const {
    leftBox,
    leftInnerBox,
    leftTextWrapper,
    leftHeading,
    leftSubText,
    bannerBox,
    smallScreenHeading,
  } = muiCustomStyles;

  return (
    <Box sx={leftBox}>
      <Box sx={leftInnerBox}>
        <Box sx={leftTextWrapper}>
          <Box sx={{ display: { xs: "flex", sm: "none" } }}>
            <Typography color="rgba(62, 63, 76, 1)" sx={smallScreenHeading}>
              {t("welcomeTitle")}
            </Typography>
          </Box>

          <Typography color="rgba(62, 63, 76, 1)" sx={leftHeading}>
            {t("welcomeHeading")}
            <Typography component="span" sx={{ display: "inline-flex" }}>
              <img
                src="/icons/wave-hand.svg"
                alt="wave-hand"
                width="37px"
                height="37px"
              />
            </Typography>
          </Typography>

          <Typography color="rgba(62, 63, 76, 1)" sx={leftSubText}>
            {t("welcomeParagraph")}
          </Typography>
        </Box>
      </Box>
      <Box sx={bannerBox}></Box>
    </Box>
  );
};

const RightSlide = ({
  showButton = false,
  onClose,
  keilotEmail,
  keilotPhone,
  isCommunityManagementRole,
}) => {
  const { t } = useTranslation("welcome");
  const showSnackbar = useSnackbar();
  const {
    rightBox,
    rightScrollBox,
    rightTextWrapper,
    rightHeadingWrapper,
    rightHeading,
    rightHeading2,
    rightParagraph,
    rightParagraphLast,
    helpTitle,
    helpSubText,
    iconButtonWrapper,
    buttonWrapper,
    gotItButton,
  } = muiCustomStyles;

  return (
    <Box sx={rightBox}>
      <Box sx={rightScrollBox}>
        <Box sx={rightTextWrapper}>
          <Box sx={rightHeadingWrapper}>
            <Typography color="rgba(62, 63, 76, 1)" sx={rightHeading}>
              {isCommunityManagementRole ? t("admin.rightHeading") : t("rightHeading")}
            </Typography>
            {!isCommunityManagementRole && (
              <Typography color="rgba(62, 63, 76, 1)" sx={rightHeading2}>
                {t("rightHeading2")}
              </Typography>
            )}
          </Box>
          <Typography color="rgba(62, 63, 76, 1)" sx={rightParagraph}>
            {isCommunityManagementRole ? t("admin.rightParagraph1") : t("rightParagraph1")}
          </Typography>
          <Typography color="rgba(62, 63, 76, 1)" sx={rightParagraph}>
            {isCommunityManagementRole ? t("admin.rightParagraph2") : t("rightParagraph2")}
          </Typography>
          <Typography color="rgba(62, 63, 76, 1)" sx={rightParagraphLast}>
            {isCommunityManagementRole ? t("admin.rightParagraph3") : t("rightParagraph3")}
          </Typography>

          <Box>
            <Typography color="rgba(62, 63, 76, 1)" sx={helpTitle}>
              {t("helpTitle")}
            </Typography>
            <Typography color="rgba(62, 63, 76, 1)" sx={helpSubText}>
              {t("helpSubText")}
            </Typography>

            <Box sx={iconButtonWrapper}>
              <CustomTooltip title={t("copyEmail")} placement="bottom">
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(keilotEmail);
                    showSnackbar(`${t("user_copy_email")}`, "success");
                  }}
                >
                  <img src="/icons/mail-forward.svg" alt="mail-forward" />
                </IconButton>
              </CustomTooltip>
              <CustomTooltip title={t("copyPhone")} placement="bottom">
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(keilotPhone);
                    showSnackbar(`${t("user_copy_phone")}`, "success");
                  }}
                >
                  <img src="/icons/phone-outgoing.svg" alt="phone-outgoing" />
                </IconButton>
              </CustomTooltip>
              <CustomTooltip title={t("openWhatsapp")} placement="bottom">
                <IconButton
                  onClick={() => {
                    window.open(
                      `https://api.whatsapp.com/send/?phone=${keilotPhone}&text=${t(
                        "help_whatsapp_message_text",
                        { ns: "bottom-menu-and-settings" }
                      )}&app_absent=0`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  <img src="/icons/whatsapp-icon.svg" alt="whatsapp-icon" />
                </IconButton>
              </CustomTooltip>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ ...buttonWrapper, display: { xs: "none", sm: "flex" } }}>
        <Button onClick={onClose} sx={gotItButton}>
          {t("gotItButton")}
        </Button>
      </Box>
    </Box>
  );
};

const WelcomePopup = ({ open, onClose, keilotEmail, keilotPhone, isCommunityManagementRole }) => {
  const { t } = useTranslation("welcome");
  return (
    <GenericSwiperDialog
      open={open}
      onClose={onClose}
      dialogTitle={t("welcomeTitle")}
      leftContent={<LeftSlide />}
      rightContent={
        <RightSlide
          showButton
          onClose={onClose}
          keilotEmail={keilotEmail}
          keilotPhone={keilotPhone}
          isCommunityManagementRole={isCommunityManagementRole}
        />
      }
    />
  );
};

export default WelcomePopup;
